export default import.meta.ROLLDOWN_FILE_URL_DbZG8THMSq98_7dKP536Bg